import React from "react";
import { HashRouter, Route } from "react-router-dom";

import ProductPage from "pages/ProductPage";
import Scheduling from "pages/Scheduling";
import ReadOnlyBrief from "pages/ReadOnlyBrief";
import NoDifyMessage from "pages/NoDifyMessage";
import DSBriefModel from "models/DSBriefModel";

class Router extends React.Component {
  render() {
    const showNoDifyMessage = window.utag_data.Language !== "en-in";
    if (DSBriefModel.isReadOnly) {
      return (
        <HashRouter hashType="noslash">
          <div>
            <Route path="*" component={ReadOnlyBrief} />
          </div>
        </HashRouter>
      );
    } else if (showNoDifyMessage) {
        return (
            <HashRouter hashType="noslash">
            <div>
              <Route path="*" component={NoDifyMessage} />
            </div>
          </HashRouter>
        )
    } else {
      return (
        <HashRouter hashType="noslash">
          <div>
            <Route path="/" exact component={ProductPage} />
            <Route path="/schedule" exact component={Scheduling} />
          </div>
        </HashRouter>
      );
    }
  }
}

export default Router;



// WEBPACK FOOTER //
// ./src/Router.js